import '../../../../@ant-design/cssinjs/es/extractStyle.js';
import '../../../../@ant-design/cssinjs/es/hooks/useCacheToken.js';
import '../../../../rc-util/es/Dom/dynamicCSS.js';
import 'react';
import '../../../../@ant-design/cssinjs/es/StyleContext.js';
import '../../../../@ant-design/cssinjs/es/util/index.js';
import '../../../../@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js';
import '../../../../@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js';
import '../../../../@ant-design/cssinjs/es/hooks/useHMR.js';
import useStyleRegister from '../../../../@ant-design/cssinjs/es/hooks/useStyleRegister.js';
import '../../../../rc-util/es/warning.js';
import '../../../../@ant-design/cssinjs/es/theme/createTheme.js';
import '../../../../@ant-design/cssinjs/es/theme/ThemeCache.js';
import '../../../../@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js';
import '../../../../@emotion/unitless/dist/unitless.cjs.js';
import { resetIcon } from '../../style/index.js';
import useToken from '../useToken.js';
const useResetIconStyle = (iconPrefixCls, csp) => {
  const [theme, token] = useToken();
  // Generate style for icons
  return useStyleRegister({
    theme,
    token,
    hashId: '',
    path: ['ant-design-icons', iconPrefixCls],
    nonce: () => csp === null || csp === void 0 ? void 0 : csp.nonce,
    layer: {
      name: 'antd'
    }
  }, () => [{
    [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, resetIcon()), {
      [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
        display: 'block'
      }
    })
  }]);
};
var useStyle = useResetIconStyle;
export { useStyle as default };
//# sourceMappingURL=useResetIconStyle.js.map
